module.exports = __webpack_public_path__ + "static/img/333_TO8_2562.fca0ad7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/333_TO8_2562.jpg
// module id = MhEF
// module chunks = 0